module.exports = __webpack_public_path__ + "static/media/34DSS5.5fc985f7.jpg";